import cn from 'classnames';
import React from 'react';
import { useModel } from 'umi';
import TopicHeader from '../TopicHeader';

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  header?: React.ReactNode;
  headerClassName?: string;
  children?: React.ReactNode;
  compact?: boolean;
}

const PageWrapper: React.FC<IProps> = ({ header, children, compact = false, ...restProps }) => {
  const { isMobile } = useModel('media');
  const cls = cn({ 'flex-1 overflow-y-auto': !isMobile, 'p-6 max-md:p-2': !compact });
  return (
    <>
      {header && <TopicHeader>{header}</TopicHeader>}
      <div className={cls} {...restProps}>
        {children}
      </div>
    </>
  );
};

export default PageWrapper;
